import type { Domain } from '@connected/api-client/lib/portal';

import { isAuthenticated } from '@connected/api-client/lib/authentication';
import { isProjectPath } from '@connected/api-client/lib/login';
import { DOMAIN_KEYS } from '@connected/api-client/lib/portal';
import { generateSSOUrl } from '@connected/api-client/lib/sso';
import {
    createFileRoute,
    Link,
    Outlet,
    redirect,
} from '@tanstack/react-router';

import logo from '@/assets/logo.png';

export const Route = createFileRoute('/_unauth')({
    component: RouteComponent,
    beforeLoad: async ({ location }) => {
        if (!isAuthenticated())
            return;

        // Check if there's a redirect or redirectPath in the search params
        const searchParams = new URLSearchParams(location.search);
        const redirectParam = searchParams.get('redirect') || searchParams.get('redirectPath');
        const fromParam = searchParams.get('from') as Domain | null;

        // Ensure the redirect path is absolute (starts with /)
        const redirectPath = redirectParam
            ? (redirectParam.startsWith('/') ? redirectParam : `/${redirectParam}`)
            : null;

        // If from external app with project path, redirect back via SSO
        if (fromParam && DOMAIN_KEYS.includes(fromParam) && fromParam !== 'portaal') {
            if (redirectPath && isProjectPath(redirectPath)) {
                const ssoUrl = generateSSOUrl({
                    targetDomain: fromParam,
                    redirectPath,
                });
                if (ssoUrl) {
                    throw redirect({ href: ssoUrl });
                }
            }
        }

        // Default: internal portaal navigation
        throw redirect({
            to: redirectPath || '/customer/locations',
        });
    },
});

function RouteComponent() {
    const currentYear = new Date().getFullYear();

    return (
        <div className="min-h-screen flex flex-col justify-between">
            <div className="p-8">
                <Link to="/">
                    <img src={logo} className="h-8 object-fill" />
                </Link>
            </div>
            <Outlet />
            <div className="p-8 text-left">
                &copy; Connected
                {' '}
                {currentYear}
            </div>
        </div>
    );
}
